<div class="hidden-from-ssr" {style}>
  <slot></slot>
</div>
<script>
  export default {
    computed: {
      style ({ $isUserLoggedIn }) {
        return ENAFORE_IS_BROWSER && !$isUserLoggedIn ? '' : 'opacity: 0'
      }
    }
  }
</script>
